import React, { useState } from 'react'
import { BasicButton, SendIcon } from '../../../../..'
import { APIRequest } from '../../../../../../api'
import css from './ResendVerificationEmailButton.module.scss'
import { useTranslation } from 'react-i18next'
import { extractResponseError } from '@lynx/core'
import { InputMessages } from '../../../../../Input/InputMessages'

interface ResendVerificationEmailButtonProps {
	email: string
	password: string
}

export const ResendVerificationEmailButton = ({ email, password }: ResendVerificationEmailButtonProps): React.ReactElement => {
	const [isLoading, setIsLoading] = useState(false)
	const { t } = useTranslation()
	const [errorMessage, setErrorMessage] = useState('')
	const [successMessage, setSuccessMessage] = useState('')

	const handleResendVerification = async (): Promise<void> => {
		try {
			setErrorMessage('')
			setSuccessMessage('')
			setIsLoading(true)
			await APIRequest.User.resendVerificationEmail(email, password)
			setSuccessMessage(t('pages.login.verificationEmailSent'))
		} catch (error: unknown) {
			const responseError = extractResponseError(error, { isExpectingOptions: false })
			if (responseError) setErrorMessage(responseError.message)
			else if (error instanceof Error) setErrorMessage(error.message)
		} finally {
			setIsLoading(false)
		}
	}

	return (
		<div className={css.container}>
			<BasicButton onClick={handleResendVerification} className={css.btn} isLoading={isLoading} variant="light" size="xs" icon={SendIcon}>
				{t('pages.login.resendVerification')}
			</BasicButton>
			{(errorMessage || successMessage) && (
				<InputMessages
					messages={[
						...(errorMessage ? [{ message: errorMessage, type: 'error' as const }] : []),
						...(successMessage ? [{ message: successMessage, type: 'info' as const }] : [])
					]}
				/>
			)}
		</div>
	)
}
